var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.type, 'loader'],attrs:{"id":_vm.id}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner-centered"},[_c('div',{staticClass:"cube1"}),_vm._v(" "),_c('div',{staticClass:"cube2"})])
}]

export { render, staticRenderFns }